import React, { useMemo } from 'react';
import { Button } from '@/components/Button/Button';
import { VehicleParameterItem } from '@/components/Raport/RaportMainParams/VehicleParameters/VehicleParameterItem';

export interface VehicleIdentificationData {
  brand: string;
  model: string;
  generation: string;
  version: string;
  productionYear: string;
  modelYear: string;
  vin: string;
  countryOfOrigin: string;
  faceliftYear: string;
  productionStartDate: string;
  productionEndDate: string;
}

export interface RaportHSPVehicleIdentificationProps {
  data: VehicleIdentificationData;
  onShowFullVehicleCard?: () => void;
}

export const RaportHSPVehicleIdentification: React.FC<
  RaportHSPVehicleIdentificationProps
> = ({ data, onShowFullVehicleCard }) => {
  const fillColor = useMemo(() => '#A4B2C0', []);
  return (
    <div className="mt-6 w-full lg:mt-10">
      <div className="flex flex-wrap gap-5 items-center py-5 bg-white rounded-2xl border border-violet-100 border-solid">
        <VehicleParameterItem
          label="Marka i model"
          value={`${data.brand} ${data.model}`}
          fillColor={fillColor}
          icon="shield"
        />

        <VehicleParameterItem
          label="Generacja"
          value={data.generation}
          icon="sun"
          fillColor={fillColor}
        />

        <VehicleParameterItem
          label="Wersja"
          value={data.version}
          fillColor={fillColor}
          icon="car"
        />

        <VehicleParameterItem
          label="Rok produkcji i rok modelowy"
          value={`${data.productionYear} / ${data.modelYear}`}
          fillColor={fillColor}
          icon="vin-number"
        />

        <VehicleParameterItem
          label="Numer VIN"
          value={data.vin}
          fillColor={fillColor}
          icon="vin-number"
        />

        <VehicleParameterItem
          label="Kraj pochodzenia"
          value={data.countryOfOrigin}
          fillColor={fillColor}
          icon="location-pin"
        />

        <VehicleParameterItem
          label="Data faceliftingu"
          value={data.faceliftYear}
          fillColor={fillColor}
          icon="excel-file"
        />

        <VehicleParameterItem
          label="Data rozpoczęcia produkcji"
          value={data.productionStartDate}
          fillColor={fillColor}
          icon="calendar-date"
        />

        <VehicleParameterItem
          label="Data zakończenia produkcji"
          value={data.productionEndDate}
          fillColor={fillColor}
          icon="calendar-date"
        />
      </div>

      <div className="flex justify-start mt-8">
        <Button variant="gold" onClick={onShowFullVehicleCard}>
          Zobacz pełną kartę pojazdu
        </Button>
      </div>
    </div>
  );
};
